import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import CreateStory from "@/pages/CreateStory";
import Dashboard from "@/pages/Dashboard";
import OrderView from "@/pages/OrderView";

function App() {
    return (
        <div className="App">
            <Toaster position="top-center" richColors />
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/login" element={<AuthPage mode="login" />} />
                    <Route path="/signup" element={<AuthPage mode="signup" />} />
                    <Route path="/create" element={<CreateStory />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/order/:orderId" element={<OrderView />} />
                    <Route path="*" element={<Navigate to="/" />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
